import React from "react"

export function InfoField(props: React.PropsWithChildren<{ label: string, title?: string }>) {
  return <div className={"info-field"}>
    <div title={props.title} className={"label"}>{props.label}</div>
    <div className={"info"}>{props.children}</div>
  </div>
}